export class FacturaDetalle {
    BILL_DETAIL_ID: number;
	BILL_ID: number;
	ITEM_SAT_ID: number;
	ITEM_ID: number;
	UNIT_MEASURE_ID: number;
	AMOUNT: number; // Sin iba 16%
	QUANTITY: number;
	DESCRIPTION: string;
	IVA_FACTOR: number;  // IVA 16%
	IVA_AMOUNT: number;  // 20 PESOS 16 %
	DOCUMENT_DETAIL_ID: number;
	isChecked: boolean;
	checkedIva: boolean;
	total: number;
	totalFaltante: number;
	price: number;
	index: number;
	NAME: string; // Producto
	NAME_SAT: string; // sat
	unidad: string;
	DOCUMENT_ID: number;
	AMOUNT_ORIGINAL: number; // Sin iba 16%
	PREDIAL_ID:number;
	NAME_PREDIAL:number;
	impuestoRetenido:any;
	TYPE:string;
	//STOCK: number; // Requerido
}



// WEBPACK FOOTER //
// ./src/app/models/facturaDetalle.ts